import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Icon from '../../../ui/Icon'
import { Button } from '../../../buttons/Button'

import { PartnerModel } from '../../../../types/court/court'
import { initials } from '../../../../utils/profile/profile'

type SavedPartnersProps = {
  partners: PartnerModel[] | null
}

export const SavedPartners = ({ partners }: SavedPartnersProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation('dashboard')

  const goTo = (path: string) => {
    navigate(path)
  }

  return (
    <>
      <div className="ph-row ph-between mb-3">
        <h3>{t('dashboard.saved-partners.saved-partners')}</h3>
        <Button
          label={t('dashboard.saved-partners.add-btn')}
          icon={<Icon name="plus" size={13} />}
          variant="ghost"
          size="sm"
          onClick={() => goTo('/partners')}
        />
      </div>
      <div className="ph-col gap-2">
        {partners === null ? (
          <div className="muted" aria-hidden="true">
            &mdash;
          </div>
        ) : partners.length === 0 ? (
          <div className="muted">{t('dashboard.saved-partners.empty')}</div>
        ) : (
          partners.map(partner => (
            <div className="partner-card" key={partner.id}>
              <div className="ph-avatar sm">
                {initials(`${partner.lastName} ${partner.firstName}`)}
              </div>
              <div className="info">
                <div className="name">
                  {`${partner.lastName} ${partner.firstName}`}
                  {partner.favorite && (
                    <Icon className="favorite-icon" name="star" size={12} />
                  )}
                </div>
                <div className="email">
                  {t('dashboard.saved-partners.games', {
                    email: partner.email,
                    games: partner.gamesPlayed,
                  })}
                </div>
              </div>
              <Button
                label={t('dashboard.saved-partners.book-together')}
                icon={<Icon name="calendar" size={13} />}
                variant="ghost"
                size="sm"
                onClick={() => goTo('/booking')}
              />
            </div>
          ))
        )}
      </div>
    </>
  )
}
